//SET_FILTERS

export const setPartsFilters = (payload =
    {
        beginDate : '',
        endDate   : '',
        version   : '',
        fullDump  : false
    }) => ({
    type : 'SET_PARTS_FILTERS',
    payload
});

//SET_BEGIN_DATE_FILTER
export const setBeginDatePartsFilter = (beginDate) => ({
    type : 'SET_BEGIN_DATE_PARTS_FILTER',
    beginDate
});

//SET_END_DATE_FILTER
export const setEndDatePartsFilter = (endDate) => ({
    type : 'SET_END_DATE_PARTS_FILTER',
    endDate
});
//SET_FORMAT_VERSION_FILTER
export const setFormatVersionPartsFilter = (version) => ({
    type : 'SET_FORMAT_VERSION_PARTS_FILTER',
    version
});

export const setFullPartDump = (fullDump) => ({
    type : 'SET_FULL_PART_DUMP',
    fullDump
});



// WEBPACK FOOTER //
// ./src/Actions/partsFilters.js